import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';

// import { access } from 'fs';
import { AuthenticationService } from '../services/authentication.service';
import { BASE_OSM_URL } from "@app/app.constants";

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    accessToken: string;

    constructor(
        private authenticationService: AuthenticationService, 
        // private cookieService: CookieService
        ) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const currentUser = localStorage.getItem('currentUser');

        if (currentUser) {
            this.accessToken = JSON.parse(currentUser).access_token;
        }

        if (this.accessToken && !request.url.includes(BASE_OSM_URL)) {
            request = request.clone({
                setHeaders: {
                    // 'Content-Type' : 'application/json; charset=utf-8',
                    'Accept'       : 'application/json',
                    'Authorization': `Bearer ${this.accessToken}`
                },
            });
        }
        return next.handle(request);
    }
}
